import { Component, inject, input } from '@angular/core';
import { PdfChartExporterComponent } from '../ui/pdf-chart-exporter/pdf-chart-exporter.component';
import { take } from 'rxjs';
import { Chart } from '@ex/module/core/modules/chart/builder';
import { BaseComponent } from '@ex/module/core/domain/base-component';
import { KeyName } from '@ex/survey-x/index';
import { JsonToExcelComponent } from '../../export-components/json-to-excel/json-to-excel.component';
import { ZenCDKService } from '../../Theme/services/zen-cdk.service';

export interface ExportChartData {
  classes?: string
  title?: string

}
export interface ExcelChartOptions {
  grouping?: boolean
  title?: string,
  modify?: (row) => {};
  header?: KeyName[];
}

@Component({
  selector: 'app-chart-base',
  standalone: false,

  template: `
    <p>
      chart-base works!
    </p>
  `,
  styles: ``
})
export class NewChartBaseComponent {



  private _zenCDK = inject(ZenCDKService);

  protected get ZenCDKService(): ZenCDKService {
    return this._zenCDK;
  }


  readonly chart = input<Chart>();

  exportPdf(elementId: any, data: ExportChartData = {}, language = 'EN') {
    const chart = this.chart()
    if (!data?.title)
      data.title = this.chart()?.title;
    chart!.setExport(true).build;
    setTimeout(() => {
      this.initChartExport(elementId, language, data)
    }, 1500);
  }

  initChartExport(elementId, language, data?,) {
    const element: HTMLElement = document.querySelector(`[data-chart="${elementId}"]`)!;
    const chartHTML = element.cloneNode(true)
    this.ZenCDKService.openComponent(PdfChartExporterComponent, {
      chartHTML,
      language,
      ...data
    }).pipe(take(1)).subscribe({
      next: x => {
        this.chart()?.setExport(false).build();
      }
    });
  }

  exportExcel(chartData: Chart, data?: ExcelChartOptions) {
    const excelData = this.prepareExcelData(chartData);
    this.ZenCDKService.openComponent(JsonToExcelComponent, {
      data: excelData,
      name: data?.title ?? chartData?.title,
      includeTitle: true,
      ...data,
      modify: data?.modify ?? this.modifyRow
    })
  }

  /**
   * Prepares chart data for Excel export by extracting data from chart series
   * @param chart Chart instance containing series data
   * @returns Array of objects suitable for Excel export
   */
  private prepareExcelData(chart: Chart): any[] {
    const chartOptions = chart.chart$.value;
    const series = chartOptions.series || [];
    const categories = chart.categories || [];

    // Handle single series (pie chart or single column/bar)
    if (series.length === 1) {
      return series[0].data.map((item: any, index: number) => ({
        Category: categories[index] || item.name || `Item ${index + 1}`,
        Value: parseFloat(item.value || item || 0)
      }));
    }

    // Handle multiple series (grouped/stacked charts)
    const excelData: any[] = [];
    categories.forEach((category, catIndex) => {
      const row: any = { Category: category };
      series.forEach((s: any) => {
        const seriesName = s.name || `Series ${catIndex + 1}`;
        const dataPoint = s.data[catIndex];
        row[seriesName] = parseFloat(dataPoint?.value || dataPoint || 0);
      });
      excelData.push(row);
    });

    return excelData;
  }

  modifyRow = (row: any) => {
    row.eachCell((cell: any) => {
      if (typeof cell.value === 'number') {
        cell.value = isNaN(cell.value) ? 0 : cell.value;

        cell.numFmt = '0.0%';
        cell.value = cell.value / 100;
      }
    });
  };

  logData(data: any) {
    console.log(data);
  }

}
